import React from "react";
import { Button } from "react-bootstrap";
import "./style/home.scss";

function Home() {
  return (
    <div className="login">
      <div className="label">Working?</div>
      <div className="login-info">Login as an employee</div>
      <Button href="/login" className="login-button wwu-button">
        Login
      </Button>
    </div>
  );
}

export default Home;
